import { render, staticRenderFns } from "./uploadPopup.vue?vue&type=template&id=c1af6dca&scoped=true"
import script from "./uploadPopup.vue?vue&type=script&lang=js"
export * from "./uploadPopup.vue?vue&type=script&lang=js"
import style0 from "./uploadPopup.vue?vue&type=style&index=0&id=c1af6dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1af6dca",
  null
  
)

export default component.exports